import { Chip, ChipPicker } from '@tableau/widgets';
import * as React from 'react';
import { useState } from 'react';

import { Recipient } from '../types/SubscribeRecipient';

const LIST_MAX_HEIGHT = 150;
const MAX_LINES = 2;

export interface SubscribeRecipientPickerProps {
  readonly recipients: Recipient[];
  readonly label: string;
  readonly placeholder: string;
  // readonly height: number;
  // onRecipientAdd: (recipient: Recipient, index: number) => void;
  // onRecipientsChange: (recipients: Recipient[]) => void;
  // externalComponentUpdate: () => void;
  // selfSubscribeStateUpdate: (updateRequired: boolean) => void;
  // debounceTimeout: number;
  // showNoEmailAsErrorChip: boolean;
}

export function SubscribeRecipientPicker(props: SubscribeRecipientPickerProps) {
  const [recipients, setRecipients] = useState(props.recipients);
  const [filter, setFilter] = useState('');

  const handleValueAdded = () => '';
  const handleValuesChanged = () => '';

  return (
    <ChipPicker
      label={props.label}
      listItems={[]}
      listMaxHeight={LIST_MAX_HEIGHT}
      placeholder={props.placeholder}
      testId={''}
      maxLines={MAX_LINES}
      onFilterItems={setFilter}
      onValueAdd={handleValueAdded}
      onValuesChange={handleValuesChanged}
      className={''}
      // style = {{height: props.height, marginBottom: 8}}
      style = {{ marginBottom: 8}}
    >
      {
        props.recipients.map((recipient) => {
          const name = recipient.recipientType === 'USER' ? recipient.friendlyName : recipient.name;
          const tooltip = recipient.recipientType === 'USER' ? recipient.username : recipient.name;

          return <Chip key={getRecipientKey(recipient)} tooltip={tooltip} value={name}>
            {name}
          </Chip>;
        })
      }
    </ChipPicker>
  );
}

/**
 * Creates a unique string value from a recipient's id and type. This is necessary to maintian uniqueness across
 * both users and groups which could share id values.
 */
function getRecipientKey(recipient: Recipient): string {
  return `${recipient.recipientType}_${recipient.id}`;
}